var arrow = 'M32.4,50L75.8,6.6c1.5-1.5,1.5-3.9,0-5.4c-1.5-1.5-3.9-1.5-5.4,0L24.2,47.3c-1.5,1.5-1.5,3.9,0,5.4l46.2,46.2 c1.5,1.5,4,1.4,5.4-0.1c1.4-1.5,1.4-3.9,0-5.3L32.4,50z';
var logo_settings = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false, // custom by Archetype
      childNav: null, // element. Custom by Archetype instead of asNavFor
      childNavScroller: null, // element
      childVertical: false,
      fade: false,
      initialIndex: 0,
      pageDots: true,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,      
      setGallerySize: true,
      wrapAround: true,
      arrowShape: arrow
    };

var promo_settings = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false, // custom by Archetype
      childNav: null, // element. Custom by Archetype instead of asNavFor
      childNavScroller: null, // element
      childVertical: false,
      fade: false,
      initialIndex: 0,
      pageDots: true,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,      
      setGallerySize: true,
      wrapAround: true,
      arrowShape: arrow
    };
var product_settings = {
      adaptiveHeight: true,
      autoPlay: false,
      avoidReflow: false, // custom by Archetype
      childNav: null, // element. Custom by Archetype instead of asNavFor
      childNavScroller: null, // element
      childVertical: false,
      fade: false,
      initialIndex: 0,
      pageDots: true,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,      
      setGallerySize: true,
      wrapAround: true,
      arrowShape: arrow,
  	  cellAlign: 'left'
    };

if ( matchMedia('screen and (max-width: 768px)').matches ) { 
	var Logo = new Flickity('.index-section--icons .logo-bar', logo_settings);
  	var Promo = new Flickity('.index-section--promo_grid .flex-grid--slider', promo_settings);
  
    var Product = new Flickity('.grid_image_layout .product-slideshow', product_settings);
}


$(document).ready(function(){
  $(document).on("click","[data-sliderule-open]",function(){
    var target_div = $(this).attr("data-sliderule-open");
    $("#"+target_div).addClass("is-visible");    
    var crrentPage = parseInt($(".drawer__menu").attr('data-sliderule-pane')) + 1;
    $(".drawer__menu").attr("data-sliderule-pane",crrentPage);
  });
  $(document).on("click","[data-sliderule-close]",function(){
    var target_div = $(this).attr("data-sliderule-close");
    $("#"+target_div).removeClass("is-visible");
    var crrentPage = parseInt($(".drawer__menu").attr('data-sliderule-pane')) - 1;
    $(".drawer__menu").attr("data-sliderule-pane",crrentPage);
  });
  
  $(document).on("click",".collection-filter_btn",function(){
    var target_div = $('.boost-pfs-filter-tree');
    if(target_div.hasClass('open')){
      target_div.removeClass('open');
      target_div.slideUp();
    }
    else{
      target_div.addClass('open');
      target_div.slideDown();
    }    
  });
  
  
});


if(window.outerWidth >= 375 && window.outerWidth <=768){
  $( window ).scroll(function() {
    if($(window).scrollTop()>0){
      $("#NavDrawer").addClass("scroll-sticky");
    }
    if($(window).scrollTop()==0){
      $("#NavDrawer").removeClass("scroll-sticky");
    }
  });
}





//--- Browser Details ---//
$(document).ready(function() {  
function getBroswerDetails() {
    //Checking the user's OS and Browser
    if ((navigator.userAgent).includes("Android")) {
      $("html").addClass("android");
    } else if ((navigator.userAgent).includes("Mac")) {
      $("html").addClass("mac");
    } else {
      $("html").addClass("windows");
    }


    //-- Browser --//
    var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    var isFirefox = typeof InstallTrigger !== 'undefined';
    var isSafari = /constructor/i.test(window.HTMLElement) || (function(p) {
      return p.toString() === "[object SafariRemoteNotification]";
    })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
    var isIE = /*@cc_on!@*/ false || !!document.documentMode;
    var isEdge = !isIE && !!window.StyleMedia;
    var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
    var isBlink = (isChrome || isOpera) && !!window.CSS;
    if (isFirefox) {
      $("html").addClass("isFirefox")
    } else if (isChrome) {
      $("html").addClass("isChrome")
    } else if (isSafari) {
      $("html").addClass("isSafari")
    } else if (isOpera) {
      $("html").addClass("isOpera")
    } else if (isIE) {
      $("html").addClass("isIE")
    } else if (isEdge) {
      $("html").addClass("isEdge")
    } else if (isEdgeChromium) {
      $("html").addClass("isEdgeChromium")
    } else {
      $("html").addClass("isBlink a")
    }
  }
  
   getBroswerDetails();
  
});



PageInits = {
  //=== Collection Page ===================================================
  collection: function(a){
    var top = 0;
    var main = $(a);
    var randomClass = ( 'eH' + Math.random() ).replace('.','');
    // console.log('A random class: ' + randomClass); // ?
    main.each( function() {

      var distanceFromTop = $(this).offset().top;
      // console.log('This is ' + distanceFromTop + ' from the top.');

      if ( distanceFromTop > top ) {
        $('.' + randomClass).removeClass(randomClass);
        top = distanceFromTop;
        // console.log('"top" is ' + top + 'px away');
      }

      $(this).addClass(randomClass);

      $(this).css('min-height','auto');

      var newHeight = (Math.max.apply(null, $('.' + randomClass).map( function() {
        return $(this).outerHeight();
      }).get()));

      $('.' + randomClass).css('min-height',newHeight);

    }).removeClass(randomClass);

  }
}

$( window ).scroll(function() {
  PageInits.collection('.grid-product__colors:not(.cusrom-color-tag-main)');
  PageInits.collection('.cusrom-color-tag-main');
  PageInits.collection('.grid-product__meta');  
  PageInits.collection('.grid-product__sizes');
  
  setTimeout(function(){   $('.pagination .next').prev().addClass('last');
//   console.log($('.pagination .next').prev());
  PageInits.collection('.grid-product__colors:not(.cusrom-color-tag-main)');
  PageInits.collection('.cusrom-color-tag-main');
	}, 1000);
  
});

$(document).ready(function() {  
  PageInits.collection('.grid-product__colors:not(.cusrom-color-tag-main)');
  PageInits.collection('.cusrom-color-tag-main');
  PageInits.collection('.grid-product__meta');    
  PageInits.collection('.grid-product__sizes');
  setTimeout(function(){   $('.pagination .next').prev().addClass('last');
//   console.log($('.pagination .next').prev());
	}, 1000);
  
});

$( window ).resize(function() {  
  PageInits.collection('.grid-product__colors:not(.cusrom-color-tag-main)');
  PageInits.collection('.cusrom-color-tag-main');
  PageInits.collection('.grid-product__meta');    
  PageInits.collection('.grid-product__sizes');
  
  if ( matchMedia('screen and (max-width: 768px)').matches ) { 
	var Logo = new Flickity('.index-section--icons .logo-bar', logo_settings);
  	var Promo = new Flickity('.index-section--promo_grid .flex-grid--slider', promo_settings);
  
    var Product = new Flickity('.grid_image_layout .product-slideshow', product_settings);
}
  
});

$(document).ready(function() {  
  $(document).on("click",".boost-pfs-filter-option-item .boost-pfs-filter-button",function(){
    setTimeout(function(){
      $('.drawer__close .drawer__close-button.js-drawer-close').trigger("click");
    },1000)
  });
  
  
 /*Anax Cart Continue shhopping btn*/
  $(document).on("click",".continue_shipping-wrapper .btn_continue_shipping",function(){
    $(".drawer__close-button.js-drawer-close").trigger("click");
  });
  
  /* ajax cart toggle collection products */
  //if(window.innerWidth<=768){
    $(document).on("click",".toggle_collection_products",function(){
      $(this).toggleClass("open");
      $(this).next('.ajax_collection-products').slideToggle("slow");
    });
  //}

  
  //Custom Swatch Hover effect
  
  $(document).on('mouseover','.custom-color--swatch',function(){
//     console.log("hii")
    var $_this = $(this),
        product_image = $_this.data("product--image");
    $_this.parents(".grid-product__content").find(".grid__image-ratio .product-image--main").attr('srcset',product_image);
  });
  $(document).on("mouseout",'.custom-color--swatch',function(){
    var $_this = $(this),
        product_image = $_this.data("current-product--image");
    $_this.parents(".grid-product__content").find(".grid__image-ratio .product-image--main").attr('srcset',product_image);
  });
  
  /*$(document).on('mouseover','.custom-color--swatch',function(){
    console.log("inn")
  },function(i){
    console.log("out")
  })*/
  
  
});